// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-area{font-size:0;text-align:center}.image-area .map-img{height:100%;max-width:100%;-webkit-user-select:none;-moz-user-select:none;user-select:none}.image-area area{cursor:pointer}.image-area.load-error{background-color:#f2f2f2!important}.image-area.load-error .el-image__error{height:1.86rem;width:1.86rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
